import React from "react";
import { Row, Col } from "react-bootstrap";
import "./CommonPrint.css";
import logo from '../../Assets/Images/happyhipposLogo-removebg-preview.png'
import {
  formatDateSeconds,
  getFullNameUser,
  formatAmount,
} from "../../Helpers/Utils/Common";

export default function CommonPrint(props) {
  const {
    type,
    paymentDetails,
    paymentBreakdown,
    orderItems,
    discounts,
    orderInfo,
    computedDiscount,
    serviceCharge,
    superGrandTotal,
    isReprint = false,
    foodServer,
  } = props;

  const appliedDiscountIds = discounts?.map((data) => {
    return data.discount_id;
  });
  const hasCharge = paymentBreakdown?.some(
    (pay) => pay.other_payment_details === "charge"
  );
  return (
    <div className="">
      <div className="print-receipt">
        <Row className="w-100 mb-4">
          <img 
            src={logo} 
            alt="logo" 
            className="logo-receipt"
          />
        </Row>
        <Row>
          <Col className="table-size" align="center">
            TABLE # {orderInfo?.table_no}
          </Col>
        </Row>
        <Row className="">{window.company_name}</Row>
        <Row className="">
          <Col sm={10} align="center">
            {window.company_address}
          </Col>
        </Row>
        <Row className="">{window.company_vat_reg_tin}</Row>
        <Row className="">{window.company_min}</Row>
        <Row className="">{window.company_sn}</Row>
        <Row className="smaller-text">{window.company_ptu_no}</Row>
        <Row className="">{window.company_issued_date}</Row>

        {isReprint && (
          <Row className="d-flex justify-content-center bolder mt-3">
            ** REPRINT **
          </Row>
        )}

        <Row className="d-flex justify-content-between mt-3">
          <Col xs={8} className="text-start">
            {type === "officialReceipt" || type === "reprint"
              ? "INVOICE"
              : "BILL OUT RECEIPT"}
          </Col>
          <Col xs={3} className="text-end">
            {paymentDetails?.id}
          </Col>
        </Row>
        <Row className="d-flex justify-content-start ms-1">
          {formatDateSeconds(new Date())}
        </Row>

        <Row className="d-flex justify-content-between mt-3">
          <Col xs={8}>ITEM</Col>
          <Col xs={4} className="text-end">
            AMOUNT
          </Col>
        </Row>
        {orderItems &&
          orderItems.map((item) => (
            <>
              <Row className="d-flex justify-content-between">
                <Col xs={8}>{`${item.qty} x ${item.menu_name} ${
                  item.is_package === "1" ? "[SET]" : ""
                } @${formatAmount(item.price)}`}</Col>
                <Col xs={4} className="text-end">
                  {formatAmount(
                    item.vat_component > 0
                      ? paymentDetails.zero_rated > 0
                        ? item.vat_component > 0
                          ? appliedDiscountIds.includes("3")
                            ? parseFloat(item.vat_ex).toFixed(2)
                            : item.price * parseFloat(item.counter)
                          : parseFloat(item.vat_ex).toFixed(2)
                        : item.price * parseFloat(item.qty)
                      : parseFloat(item.vat_ex).toFixed(2)
                  )}
                </Col>
              </Row>
              {item.is_package === "1" && (
                <div>
                  {item?.menu_details?.map((menu) => (
                    <Row className="d-flex justify-content-between">
                      <Col className="ms-4" xs={8}>{`-${menu.name}`}</Col>
                    </Row>
                  ))}
                </div>
              )}
              {item.with_modifier === "1" && (
                <div>
                  {item?.addons?.map((menu) => (
                    <Row className="d-flex justify-content-between">
                      <Col className="ms-4" xs={8}>{`-${menu.modifier_name}`}</Col>
                    </Row>
                  ))}
                </div>
              )}
            </>
          ))}
        <hr />
        <Row className="d-flex justify-content-between">
          <Col>SUBTOTAL</Col>
          {/* <Col className="text-end">{formatAmount(subTotal)}</Col> */}
          <Col className="text-end">{formatAmount(orderInfo?.subtotal)}</Col>
        </Row>
        <Row className="d-flex justify-content-between">
          <Col>TOTAL DISCOUNT</Col>
          <Col className="text-end">
            {formatAmount(computedDiscount?.total_discount ?? 0)}
          </Col>
        </Row>
        {/* {
          discounts?.map((row) => (
            <Row className="d-flex justify-content-between">
              <Col>{`${row.name} ${row.is_percentage==="1"?`(${row.percentage}%)`:""}`}</Col>
              <Col className="text-end">
                {formatAmount(row.amount ?? 0)}
              </Col>
            </Row>
          ))
        } */}
        <Row className="d-flex justify-content-between">
          <Col>VAT EXEMPTION</Col>
          <Col className="text-end">
            {formatAmount(
              computedDiscount?.total_vat_exempt ??
                paymentDetails?.vat_exemption
            )}
          </Col>
        </Row>
        <Row className="d-flex justify-content-between">
          <Col>S/C(7%)</Col>
          <Col className="text-end">
            {type === "billout"
              ? formatAmount(serviceCharge)
              : formatAmount(paymentDetails?.service_charge)}
          </Col>
        </Row>
        <Row className="d-flex justify-content-between">
          <Col className="bolder">TOTAL</Col>
          <Col className="text-center bolder">
            {orderItems?.reduce((n, { qty }) => n + parseFloat(qty), 0)} Item(s)
          </Col>
          <Col className="text-end bolder">{formatAmount(superGrandTotal)}</Col>
        </Row>

        {type !== "billout" && (
          <>
            {paymentDetails?.payment_type?.toLowerCase() === "multiple" &&
            paymentBreakdown?.length === 1 ? (
              <>
                {paymentBreakdown?.map((row) => (
                  <>
                    <Row className="d-flex justify-content-between mt-3">
                      <Col>PAYMENT TYPE</Col>
                      <Col className="text-end">
                        {row.type === "others"
                          ? row.other_payment_details?.toUpperCase()
                          : row.type.toUpperCase()}
                      </Col>
                    </Row>
                  </>
                ))}
                <Row className="d-flex justify-content-between">
                  <Col>PAID AMOUNT</Col>
                  <Col className="text-end">
                    {paymentBreakdown
                      ?.reduce(
                        (acc, payment) => acc + parseFloat(payment.amount),
                        0
                      )
                      .toFixed(2)}
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <Row className="d-flex justify-content-between mt-3">
                  <Col className="">PAYMENT TYPE</Col>
                  <Col className="text-end">MULTIPLE</Col>
                </Row>
                {paymentBreakdown?.map((row) => (
                  <>
                    <Row className="d-flex justify-content-between">
                      <Col className="ms-4">
                        {row.type === "others"
                          ? row.other_payment_details?.toUpperCase()
                          : row.type.toUpperCase()}
                      </Col>
                      <Col className="text-end">{formatAmount(row.amount)}</Col>
                    </Row>
                  </>
                ))}
                <Row className="d-flex justify-content-between">
                  <Col>TOTAL PAID AMOUNT</Col>
                  <Col className="text-end">
                    {paymentBreakdown
                      ?.reduce(
                        (acc, payment) => acc + parseFloat(payment.amount),
                        0
                      )
                      .toFixed(2)}
                  </Col>
                </Row>
              </>
            )}

            <Row className="d-flex justify-content-between">
              <Col>CHANGE</Col>
              <Col className="text-end">
                {formatAmount(paymentDetails?.change)}
              </Col>
            </Row>
            <Row className="d-flex justify-content-between">
              <Col>VAT SALES</Col>
              <Col className="text-end">
                {formatAmount(paymentDetails?.vat_sales)}
              </Col>
            </Row>
            <Row className="d-flex justify-content-between">
              <Col>VAT EXEMPT SALES</Col>
              <Col className="text-end">
                {formatAmount(paymentDetails?.vat_exempt)}
              </Col>
            </Row>
            <Row className="d-flex justify-content-between">
              <Col>ZERO-RATED SALES</Col>
              <Col className="text-end">
                {formatAmount(paymentDetails?.zero_rated)}
              </Col>
            </Row>
            <Row className="d-flex justify-content-between">
              <Col>TOTAL SALES</Col>
              <Col className="text-end">
                {formatAmount(paymentDetails?.total_sales)}
              </Col>
            </Row>
            <Row className="d-flex justify-content-between">
              <Col>TOTAL VAT</Col>
              <Col className="text-end">
                {formatAmount(paymentDetails?.vat_amount)}
              </Col>
            </Row>
            <Row className="d-flex justify-content-between">
              <Col>TOTAL DISCOUNT</Col>
              <Col className="text-end">
                {formatAmount(paymentDetails?.discount)}
              </Col>
            </Row>
            <Row className="d-flex justify-content-between">
              <Col>VAT EXEMPT</Col>
              <Col className="text-end">
                {formatAmount(paymentDetails?.vat_exemption)}
              </Col>
            </Row>
            <Row className="d-flex justify-content-between">
              <Col>S/C(7%)</Col>
              <Col className="text-end">{formatAmount(serviceCharge)}</Col>
            </Row>
            <Row className="d-flex justify-content-between">
              <Col>TOTAL AMOUNT</Col>
              <Col className="text-end">{formatAmount(superGrandTotal)}</Col>
            </Row>
          </>
        )}
        {type === "officialReceipt" ? (
          <>
            <Row className="d-flex justify-content-between mt-4">
              <Col>PS001</Col>
              <Col className="text-end">{getFullNameUser()}</Col>
            </Row>
            <Row className="d-flex justify-content-between">
              <Col>FOOD SERVER</Col>
              <Col className="text-end">{foodServer?.toUpperCase()}</Col>
            </Row>
          </>
        ) : (
          <Row className="d-flex justify-content-between mt-4">
            <Col>FOOD SERVER</Col>
            <Col className="text-end">{foodServer?.toUpperCase()}</Col>
          </Row>
        )}

        <Row className="mt-2">=========================</Row>
        <Row className="text-center">
          THIS SERVES AS {type === "billout" ? "BILL OUT RECEIPT" : "INVOICE"}
        </Row>
        <Row className="text-center">THANK YOU, PLEASE COME AGAIN</Row>

        {/* {discounts &&
          discounts.map((disc) => (
            <>
              <Row className="d-flex justify-content-between mt-3">
                <Col className="text-center">
                  {disc.discount_name?.toUpperCase()} ID:{" "}
                  {disc.senior_name
                    ? disc?.senior_id
                    : disc?.pwd_id
                    ? disc?.pwd_id
                    : disc?.id}
                </Col>
                <Col className="text-center">
                  NAME:{" "}
                  {disc?.senior_name
                    ? disc?.senior_name?.toUpperCase()
                    : disc?.pwd_name
                    ? disc?.pwd_name?.toUpperCase()
                    : disc?.name?.toUpperCase()}
                </Col>
                <Col className="text-center">SIGNATURE: ..................</Col>
              </Row>
            </>
          ))} */}

        {discounts &&
          discounts.map((disc) => {
            if (disc.discount_id !== "3") {
              return (
                <div className="mt-3">
                  <Row className="ms-3 d-flex justify-content-between">
                    <Col className="">
                      {disc.discount_name?.toUpperCase()} ID
                    </Col>
                    :
                    <Col className="text-start">
                      {disc.senior_name
                        ? disc?.senior_id
                        : disc?.pwd_id
                        ? disc?.pwd_id
                        : disc?.id}
                    </Col>
                  </Row>
                  <Row className="ms-3">
                    <Col>
                      {disc?.discount_id === "7" || disc?.discount_id === "8"
                        ? "MEMO"
                        : "NAME"}
                    </Col>
                    :
                    <Col className="text-start">
                      {disc?.senior_name
                        ? disc?.senior_name?.toUpperCase()
                        : disc?.pwd_name
                        ? disc?.pwd_name?.toUpperCase()
                        : disc?.name?.toUpperCase()}
                    </Col>
                  </Row>
                  <Row className="ms-3">
                    <Col>AMOUNT</Col>:
                    <Col className="text-start">
                      {formatAmount(disc.amount)}
                    </Col>
                  </Row>
                  <Row className="ms-3">
                    <Col>SIGNATURE</Col>:
                    <Col className="text-start">..................</Col>
                  </Row>
                </div>
              );
            }
          })}

        {(type === "officialReceipt" || type === "reprint") &&
          // <>
          //   <Row className="d-flex justify-content-between mt-3">
          //     <Col className="text-center">CUSTOMER ID</Col>:
          //     <Col className="text-end"></Col>
          //   </Row>
          //   <Row className="d-flex justify-content-between">
          //     <Col className="text-center">NAME</Col>:
          //     <Col className="text-end"></Col>
          //   </Row>
          //   <Row className="d-flex justify-content-between">
          //     <Col className="text-center">SIGNATURE</Col>:
          //     <Col className="text-end"></Col>
          //   </Row>
          // </>
          (paymentBreakdown.length > 0 && hasCharge ? (
            paymentBreakdown?.map((row) => {
              if (row.other_payment_details === "charge") {
                return (
                  <>
                    <Row className="d-flex justify-content-between mt-3">
                      <Col className="text-center">CUSTOMER ID</Col>:
                      <Col className="text-end"></Col>
                    </Row>
                    <Row className="d-flex justify-content-between">
                      <Col className="text-center">NAME</Col>:
                      <Col className="text-end">{row.reference_no}</Col>
                    </Row>
                    <Row className="d-flex justify-content-between">
                      <Col className="text-center">SIGNATURE</Col>:
                      <Col className="text-end"></Col>
                    </Row>
                  </>
                );
              }
            })
          ) : (
            <>
              <Row className="d-flex justify-content-between mt-3">
                <Col className="text-center">CUSTOMER ID</Col>:
                <Col className="text-end"></Col>
              </Row>
              <Row className="d-flex justify-content-between">
                <Col className="text-center">NAME</Col>:
                <Col className="text-end"></Col>
              </Row>
              <Row className="d-flex justify-content-between">
                <Col className="text-center">SIGNATURE</Col>:
                <Col className="text-end"></Col>
              </Row>
            </>
          ))}

        <Row className="mt-4">{window.myt_name}</Row>
        <Row className="smaller-text">{window.myt_address1}</Row>
        <Row className="">{window.myt_address2}</Row>
        <Row className="">{window.myt_vat_reg_tin}</Row>
        <Row className="">{window.myt_min}</Row>
        <Row className="">{window.myt_sn}</Row>
        <Row className="">{window.myt_ptu_no}</Row>
        <Row className="">{window.myt_acc_no}</Row>
        <Row className="">{window.myt_issued_date}</Row>
        <Row>.............................</Row>
        <Row>.............................</Row>
        <Row>.............................</Row>
      </div>
    </div>
  );
}
